import { ProductQuoteV2Dimension } from '@orus.eu/dimensions'
import type { MutaQuote } from '@orus.eu/quote'

export class MutaQuoteDimension<NAME extends string, Quote extends MutaQuote> extends ProductQuoteV2Dimension<
  NAME,
  Quote
> {}

export const mutaQuoteDimension = new MutaQuoteDimension({
  name: 'mutaQuote',
  displayKeys: { name: 'dimension_name_muta_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
